import { formatDate } from './formatDate';

export const formatDateRage = (
  from: Date | null | undefined,
  to: Date | null | undefined,
  shouldPrintWeekday: boolean = false,
): string | undefined => {
  if (!from || !to) {
    return undefined;
  }

  const today = new Date();
  const isSameYear = from.getFullYear() === to.getFullYear();
  const isSameMonth = from.getMonth() === to.getMonth();
  const isCurrentYear = from.getFullYear() === today.getFullYear();
  const shouldPrintYear = !isSameYear || !isCurrentYear;
  const shouldPrintMonth = !isSameMonth || !isSameYear || !isCurrentYear;

  return `${formatDate(from, shouldPrintYear, shouldPrintMonth, shouldPrintWeekday)} — ${formatDate(
    to,
    shouldPrintYear,
    true,
    shouldPrintWeekday,
  )}`;
};
